/** @format */
import { MarketCode } from '@mpb-com/feather/enums';
import { AxiosRequestConfig } from 'axios';

import { client } from '@toucan/client/global/axios';

import { AcceptAndGetEarningsResponse } from '../config/types';

export const acceptQuoteAndGetEarnings = async (
    transactionId: string,
    market: MarketCode,
    csrfToken: string
): Promise<AcceptAndGetEarningsResponse> => {
    const config: AxiosRequestConfig = {
        headers: {
            'X-Market': market.toLowerCase(),
            'CSRF-Token': csrfToken,
        },
    };

    const response = await client.post(
        `/transaction-service/quote/${transactionId}/accept-and-get-earnings`,
        {},
        config
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    return response.data;
};
